import { useEffect } from 'react';
import { comparativeStudyComparisonsActions } from '../../store/comparativeStudyComparisons/actions';
import { getComparativeStudyComparisonsState } from '../../store/comparativeStudyComparisons/reducer';
import { useAppDispatch, useAppSelector } from '../redux/store';

const useComparativeStudyComparisons = () => {
  const { comparisonsActiveTab, comparisonsResume, lists } = useAppSelector(
    getComparativeStudyComparisonsState,
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (
      !lists[comparisonsActiveTab] &&
      comparisonsResume[comparisonsActiveTab] > 0
    ) {
      dispatch(
        comparativeStudyComparisonsActions.fetchActiveComparativeStudyComparisons.request(
          comparisonsActiveTab,
        ),
      );
    }
  }, [comparisonsActiveTab]);

  return {
    comparisonsActiveTab,
    comparisonsResume,
    lists,
  };
};

export default useComparativeStudyComparisons;
